import { environmentConfiguration } from 'config/environment'
import WidgetComponent from 'app/components/widget_component'
import safelyExecute from 'lib/safely_execute'

safelyExecute(function(){
  const cdnHost = environmentConfiguration.cdnHost;
  const widgetClassName = "tpm-widget";
  const widgetTriggerClassName = "tpm-widget-trigger";

  const listenForDOMReady = function() {
    window.TPMListening = true;

    document.onreadystatechange = function () {
      if (document.readyState !== "loading") {
        preInitialize()
      }
    };
  };

  const preInitialize = function() {
    var ua = navigator.userAgent
    var re = /MSIE \d\.\d/ // IE9 and under
    var lteIE9 = re.test(ua)

    if (lteIE9) {
      var widgetScript = document.getElementsByClassName(widgetClassName)[0].previousElementSibling
      var polyfillScript = document.createElement('script')
      widgetScript.parentNode.insertBefore(polyfillScript, widgetScript);
      polyfillScript.onload = function() {
        initializeTPM()
      };
      polyfillScript.src = `${cdnHost}/static/xhr-or-xdr.js`
    } else {
      initializeTPM()
    }
  }

  const initializeTPM = function(event) {
    if (window.TPMInitialized) return;
    window.TPMInitialized = true;

    const elements = document.getElementsByClassName(widgetClassName);
    const triggerElements = document.getElementsByClassName(widgetTriggerClassName);

    for (var i = 0; i < elements.length; i++) {
      const element = elements[i];
      const widgetId = element.getAttribute('data-widgetid');
      const component = new WidgetComponent({ element, widgetId, triggerElements })
      component.render();
    }
  }

  window.TPMListening || listenForDOMReady();
});



/** WEBPACK FOOTER **
 ** ./app/index.js
 **/